import { IStepOrderSchedule } from "../../Interfaces/stepInterfaces";

export const STEP_ORDER_TIME_RANGE_ERROR =
  "زمان توقف باید بعد از زمان شروع یا زمان فعلی باشد.";

const getTimeInSeconds = (value: string) => {
  const [hour, minute, second = 0] = value.split(":").map(Number);

  if ([hour, minute, second].some(Number.isNaN)) return null;

  return hour * 3600 + minute * 60 + second;
};

export const hasInvalidStepOrderTimeRange = (
  schedule?: IStepOrderSchedule | null,
  startImmediately = false,
  now = new Date(),
  requireFutureStop = true,
) => {
  if (!schedule?.stopTime) return false;

  const stopTime = getTimeInSeconds(schedule.stopTime);
  if (stopTime == null) return false;

  // A blank start time has the same meaning as selecting immediate start.
  if (startImmediately || !schedule.startTime) {
    if (!requireFutureStop) return false;

    const currentTime =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    return stopTime <= currentTime;
  }

  const startTime = getTimeInSeconds(schedule.startTime);

  return startTime != null && stopTime <= startTime;
};
